import moment from 'moment';
import _find from 'lodash/find';

import {
    BOOKING_STATUS_UNAPPROVED,
    BOOKING_STATUS_APPROVED,
    BOOKING_STATUS_CHECKED_OUT,
    BOOKING_STATUS_CHECKED_IN,
    BOOKING_STATUS_CANCELLED,
} from '../constants/booking';

import { PERSON } from '../constants/fakeData/person';
import { AVAILABLE_PLANT } from '../constants/fakeData/availablePlant';
import { BOOKINGS } from '../constants/fakeData/bookings';
import { COST_CENTRES } from '../constants/fakeData/costCentres';
import { LOCATIONS } from '../constants/fakeData/locations';
import { PERSONS } from '../constants/fakeData/persons';
import { PLANT } from '../constants/fakeData/plant';
import { PLANT_TYPES } from '../constants/fakeData/plantTypes';
import { TRAVEL_REASONS } from '../constants/fakeData/travelReasons';
import { UNAVAILABLE_TIMES } from '../constants/fakeData/unavailableTimes';
import { USER } from '../constants/fakeData/user';

import {
    AUTHED_USER_URL,
    PLANT_URL,
    PLANT_TYPES_URL,
    PERSONS_URL,
    LOCATIONS_URL,
    TRAVEL_REASONS_URL,
    COST_CENTRES_URL,
    BOOKINGS_URL,
    BOOKING_STATE_ROUTE,
    BOOKING_TIME_ROUTE,
    UNAVAILABLE_TIMES_ROUTE,
    AVAILABILITY_ROUTE,
    PERSON_SETTINGS_ROUTE,
} from './api';

const matchesRoute = (url, route) => {
    return url.substr(-route.length) === route;
};

let NEXT_BOOKING_ID = 7;

export const fakeApi = (url, data, verb) => {
    let response = {};
    switch(url) {
        case AUTHED_USER_URL:
            response = USER;
            break;
        case PLANT_URL:
            response = PLANT;
            break;
        case PLANT_TYPES_URL:
            response = PLANT_TYPES;
            break;
        case PERSONS_URL:
            response = PERSONS;
            break;
        case LOCATIONS_URL:
            response = LOCATIONS;
            break;
        case TRAVEL_REASONS_URL:
            response = TRAVEL_REASONS;
            break;
        case COST_CENTRES_URL:
            response = COST_CENTRES;
            break;
        case BOOKINGS_URL:
            response = BOOKINGS;
            break;
    }
    const isAvailability = matchesRoute(url, AVAILABILITY_ROUTE);
    if (isAvailability)
        response = AVAILABLE_PLANT;

    // Update booking status
    const isStatusChange = matchesRoute(url, BOOKING_STATE_ROUTE);
    const isTimeChange = matchesRoute(url, BOOKING_TIME_ROUTE);
    const isUnavailableTimes = matchesRoute(url, UNAVAILABLE_TIMES_ROUTE);
    const isCreateBooking = matchesRoute(url, BOOKINGS_URL) && verb === `POST`;
    const isPersonSettings = matchesRoute(url, PERSON_SETTINGS_ROUTE) && verb === `GET`;

    let urlParts;
    let id;
    let booking;

    if (isStatusChange || isTimeChange || isUnavailableTimes) {
        urlParts = url.split(`/`);
        // url should be in the format: url/api/versionedUId/state
        id = urlParts[urlParts.length - 2];

        booking = _find(BOOKINGS, b => b.versionedUId === id);
    }

    if (isStatusChange || isTimeChange ) {
        booking.versionedUId += `1`;

        if (isStatusChange) {
            booking.statusId = data.statusId;

            if (data.statusId === BOOKING_STATUS_CHECKED_OUT) {
                booking.actionPermissions = { allowedStatusIdTransitions: [BOOKING_STATUS_CHECKED_IN] };
                booking.checkOutTime = moment(booking.startTime).add(10, `m`).format(`YYYY-MM-DD HH:mm:ss`);
            } else if (data.statusId === BOOKING_STATUS_CHECKED_IN) {
                booking.actionPermissions = { allowedStatusIdTransitions: null };
                booking.checkInTime = moment(booking.endTime).add(2, `m`).format(`YYYY-MM-DD HH:mm:ss`);
            } else if (data.statusId === BOOKING_STATUS_CANCELLED) {
                booking.actionPermissions = { allowedStatusIdTransitions: null };
            }
        } else if (isTimeChange) {
            // TODO: support changing the time based on status
            if (data.startTime)
                booking.startTime = data.startTime;
            if (data.endTime)
                booking.endTime = data.endTime;
        }

        response = booking;
    }

    if (isUnavailableTimes) {
        response = UNAVAILABLE_TIMES[booking.staticUId];
    }

    if (isCreateBooking) {
        const nextBookingId = NEXT_BOOKING_ID.toString();
        NEXT_BOOKING_ID++;

        response = {
            staticUId: nextBookingId,
            versionedUId: nextBookingId,
            vehiclePlantId: data.plantId,
            driverPersonId: 1,
            // Start/End time won't come back from the server momented (obviously) but need to be here
            // So the fake api works - doesn't affect normal operation
            startTime: moment(data.startTime),
            checkOutTime: null,
            endTime: moment(data.endTime),
            checkInTime: null,
            statusId: BOOKING_STATUS_APPROVED,
            passengerPersonIds: null,
            pickupLocationId: data.pickupLocationId,
            journeyToLocationId: data.journeyToLocationId,
            customJourneyToLocation: data.otherJourneyToLocation,
            returnToLocationId: data.pickupLocationId,
            costCentreIds: data.costCentreIds,
            reasonForTravel: data.travelReasonId ? TRAVEL_REASONS[data.travelReasonId].name : data.customTravelReason,
            actionPermissions: {
                allowedStatusIdTransitions: [BOOKING_STATUS_CHECKED_OUT, BOOKING_STATUS_CANCELLED],
            },
        };

        BOOKINGS[nextBookingId] = response;
    }


    if (isPersonSettings)
        response = PERSON;

    return {
        ok: true,
        status: 200,
        statusText: `CONTINUE`,
        body: response,
    };
};



// WEBPACK FOOTER //
// ./scripts/services/fakeApi.js